import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS } from "utils/Constants";
import { Image, ImageBackground, Pressable, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import React, { memo, useRef, useState } from "react";
import { SCREEN_HEIGHT, fp, hp, spH, spV, wp } from "utils/normalizeV2";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import Buttons from "components/Buttons";
import { Colors } from "colors";
import ImageView from "../../../src/image";

import VText from "components/VText";
import Heading from "components/Heading";
import { analytics } from "utils/firebaseConfig";
import { logEvent } from "firebase/analytics";
import { trackV2 } from "utils/Segment";
import { useRouter } from "expo-router";
import { useSelector } from "react-redux";

const Edits = ({ gender }) => {
    const homeStories = useSelector((state) => state.HomeReducer.homeStories) || [];
    const router = useRouter();

    if (!homeStories || homeStories?.length < 6) {
        return <></>;
    }

    return (
        <View style={styles.container}>
            {homeStories && Array.isArray(homeStories) && homeStories?.length >= 6 && (
                <>
                    <Heading type="h2" style={{
                        fontFamily: "LibreBodoni",
                        textAlign: "left",
                        fontSize: fp(32),
                        fontWeight: "100",
                        color: Colors.black,
                            alignSelf: "center",
                        }}
                        text={"The Edit"}
                    />
                </>
            )}
            <View style={styles.storyContainer}>
                {homeStories &&
                    Array.isArray(homeStories) &&
                    homeStories?.length >= 6 &&
                    homeStories.slice(3, 6).map((category, index) => (
                        <Pressable
                            key={index}
                            onPress={() => {
                                const eventData = {
                                    current_section: gender === "female" ? "Women" : "Men",
                                    story_id: category?.id,
                                };
                                trackV2(ANALYTICS_EVENT_NAMES.EDIT_STORY_IMAGE_CLICKED, eventData);
                                router.push(`/stories-details?id=${category?.id}&title=${category?.title.toLowerCase().replace(" ", "-")}&gender=${gender}`);
                            }}
                            style={[styles.categoryCard]}
                        >
                            <ImageBackground
                                ac={category?.title}
                                resizeMode={ImageView.resizeMode.cover}
                                source={{
                                    priority: ImageView.priority.high,
                                    uri: category?.thumbnailVerticalUrl || category?.imageUrl,
                                }}
                                style={[styles.categoryImage]}
                            ></ImageBackground>
                            <View
                                style={{
                                    paddingTop: spV(20),
                                }}
                            >
                                <VText numberOfLines={2} ellipsizeMode="tail" style={styles.titleText}>
                                    {category?.title}
                                </VText>
                                <VText
                                    numberOfLines={2}
                                    ellipsizeMode="tail"
                                    style={[styles.subTitleText, { paddingTop: spV(8) }]}
                                >
                                    {category?.subTitle}
                                </VText>
                                <Pressable
                                    onPress={() => {
                                        logEvent(analytics, FIREBASE_EVENT_NAMES.EDITORIAL_CLICKED, {
                                            [FIREBASE_EVENT_PARAMS.EDITORIAL_ID]: category?.id,
                                            [FIREBASE_EVENT_PARAMS.CLICKED_FROM]: "CTA_CLICKED",
                                        });
                                        const eventData = {
                                            current_section: gender === "female" ? "Women" : "Men",
                                            story_id: category?.id,
                                            cta_text: category?.cta,
                                        };
                                        trackV2(ANALYTICS_EVENT_NAMES.EDIT_STORY_CTA_CLICKED, eventData);
                                        router.push(`/stories-details?id=${category?.id}&title=${category?.title.toLowerCase().replace(" ", "-")}&gender=${gender}`);
                                    }}
                                >
                                    <VText
                                        numberOfLines={2}
                                        ellipsizeMode="tail"
                                        style={[
                                            styles.subTitleText,
                                            { paddingTop: spV(8), textDecorationLine: "underline", fontWeight: "400" },
                                        ]}
                                    >
                                        {category?.cta}
                                    </VText>
                                </Pressable>
                            </View>
                        </Pressable>
                    ))}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        marginBottom: spV(60),
    },
    storyContainer: {
        width: "100%",
        flexDirection: "row",
        paddingHorizontal: spH(74),
    },
    navButton: {
        position: "absolute",
        top: "42%",
        borderRadius: 20,
        padding: 10,
    },
    categoryCard: {
        overflow: "hidden",
        marginRight: spH(20),
        marginVertical: spV(25),
        marginBottom: 0,
    },
    categoryImage: {
        width: wp(420),
        height: wp(562),
        resizeMode: "cover",
    },
    titleText: {
        fontFamily: "LibreBodoni",
        fontSize: fp(16),
        fontWeight: "200",
        width: wp(400),
    },
    subTitleText: {
        fontSize: fp(16),
        fontWeight: "350",
        width: wp(400),
    },
});

export default memo(Edits);
